import {ApplicationStyle} from './type';
import {media} from 'typestyle';
import {MediaQuery} from 'typestyle/lib/types';

export default function createMediaQuery(query: MediaQuery) {
  return (style: ApplicationStyle) => media(query, style);
}